import { useState } from 'react';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import AddDeliveryContainer from './AddDeliveryContainer';
import CallCenterResidentContainer from './CallCenterResidentContainer';
import CallCenterVisitorContainer from './CallCenterVisitorContainer';

import { StyledTab, StyledTabs } from '../Tabs/StyledTabs';

const CallCenterStart = (props) => {
  const { t } = useTransl();
  const [value, setValue] = useState('delivery');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const {
    visitors,
    residents,
    staff,
    building,
    accessPoint,
    openAccessPointForVisitor,
    openAccessPointForPerson,
  } = props;

  const { allowResidentsLockouts, requirePhotoForVisitorLockout } = building;

  const persons = allowResidentsLockouts
    ? [...residents, ...staff]
    : [...staff];

  let content;
  switch (value) {
    case 'delivery': {
      content = <AddDeliveryContainer isCallCenter {...props} />;
      break;
    }
    case 'visitor': {
      content = (
        <CallCenterVisitorContainer
          visitors={visitors}
          building={building}
          accessPoint={accessPoint}
          openAccessPointForVisitor={openAccessPointForVisitor}
        />
      );
      break;
    }
    // residents AND staff
    case 'resident': {
      content = (
        <CallCenterResidentContainer
          persons={persons}
          requirePhotoForVisitorLockout={requirePhotoForVisitorLockout}
          accessPoint={accessPoint}
          openAccessPointForPerson={openAccessPointForPerson}
        />
      );
      break;
    }
    default: {
      content = <AddDeliveryContainer isCallCenter {...props} />;
      break;
    }
  }

  return (
    <>
      <Box display="flex" justifyContent="center" width="100%">
        <StyledTabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          TabIndicatorProps={{ style: { display: 'none' } }}
        >
          <StyledTab label={t('title.delivery')} value="delivery" />
          <StyledTab label={t('title.visitorsOrVendors')} value="visitor" />
          <StyledTab label={t('title.residentOrStaff')} value="resident" />
        </StyledTabs>
      </Box>
      <Box mb="4rem" />
      <Box>{content}</Box>
    </>
  );
};

CallCenterStart.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  building: PropTypes.instanceOf(Object).isRequired,
  accessPoint: PropTypes.instanceOf(Object).isRequired,
  visitors: PropTypes.instanceOf(Array).isRequired,
  residents: PropTypes.instanceOf(Array).isRequired,
  staff: PropTypes.instanceOf(Array).isRequired,
  openAccessPointForVisitor: PropTypes.func.isRequired,
  openAccessPointForPerson: PropTypes.func.isRequired,
};

export default CallCenterStart;
